<script setup lang="ts">
import { computed } from 'vue';
import { company } from '../config/company';

const mapEmbedUrl = computed(() => {
  const {lat, lng} = company.coordinates;
  return `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
});
</script>

<template>
  <iframe
    class="map-panel"
    :src="mapEmbedUrl"
    :title="`Google Maps - ${company.addressEn}`"
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
  />
</template>
